module.exports = __webpack_public_path__ + "static/assets/9525874be2b1d66bd448bf53400011a9.svg";